var React = require('react');

function StreamlineIconEnvelope (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"matrix(5.833333333333333,0,0,5.833333333333333,0,0)"},React.createElement("g",null,[React.createElement("path",{"d":"M11.11,14.56a1.27,1.27,0,0,0,1.77,0l9.69-9.69a.5.5,0,0,0,.12-.51.51.51,0,0,0-.4-.34L22,4H2L1.71,4a.5.5,0,0,0-.4.34.48.48,0,0,0,.12.51Z","key":0}),React.createElement("path",{"d":"M23.89,5.83a.18.18,0,0,0-.2,0l-6.2,6.2a.24.24,0,0,0,0,.36l5,5a.75.75,0,0,1-1.06,1.06l-5-5a.25.25,0,0,0-.36,0l-2.13,2.13a2.76,2.76,0,0,1-3.89,0L7.93,13.49a.24.24,0,0,0-.36,0l-5,5a.75.75,0,0,1-1.06-1.06l5-5a.24.24,0,0,0,0-.36L.31,5.87a.18.18,0,0,0-.2,0A.18.18,0,0,0,0,6V18a2,2,0,0,0,2,2H22a2,2,0,0,0,2-2V6A.18.18,0,0,0,23.89,5.83Z","key":1})])));
}

StreamlineIconEnvelope.defaultProps = {"viewBox":"0 0 140 140"};

module.exports = StreamlineIconEnvelope;

StreamlineIconEnvelope.default = StreamlineIconEnvelope;
